import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getEwalletBalance(params) {
	return client.get("ewallet/balance", {
		params: params,
	});
}

function getEwalletHistory(params) {
	return client.get("ewallet/history", {
		params: params,
	});
}

function checkClaimEwallet(params) {
	return client.get("ewallet/check/claim", {
		params: params,
	});
}

function claimEwallet(params) {
	return client.post("ewallet/claim", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getEwalletBalance,
	getEwalletHistory,
	checkClaimEwallet,
	claimEwallet,
};